import React, { useState } from "react";
import AddOns from "../components/ui/AddOns";
import PricingScale from "../components/ui/PricingScale";
import PricingTable from "../components/ui/PricingTable";

function Pricing() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "General",
      content: <PricingTable />,
    },
    {
      title: "Business",
      content: <PricingScale />,
    },
    {
      title: "Add-ons",
      content: <AddOns />,
    },
  ];

  return (
    <div className="page_overflow">
      <section className="repair_credit">
        <div className="container">
          <div className="section_title mb-2">
            <h2>Pricing</h2>
          </div>
          <div className="tabs-container mt-2">
            {/* Render tab titles */}
            <div className="tabs">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`tab ${activeTab === index ? "active" : ""}`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            {/* Render active tab content */}
            <div className="tab-content  mt-4">{tabs[activeTab].content}</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
